// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_FIREBASE,
  authDomain: "captainsconnectionsyacht.firebaseapp.com",
  projectId: "captainsconnectionsyacht",
  storageBucket: "captainsconnectionsyacht.firebasestorage.app",
  messagingSenderId: "290640788984",
  appId:process.env.REACT_APP_APP_ID,
  measurementId: "G-9E4025YBBK"
};




// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");


if (typeof window !== "undefined") {
  // dev-only: bypass captcha via debug token (recommended on localhost)
  if (process.env.NODE_ENV === "development") {
    // on first run this prints a token in the console; add it in
    // Firebase Console → App Check → your web app → Manage debug tokens
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  try {
    if (process.env.NODE_ENV === "development") {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // dev only
    }
    // initializeAppCheck(app, {
    //   provider: new ReCaptchaV3Provider("YOUR_RECAPTCHA_V3_SITE_KEY"),
    //   isTokenAutoRefreshEnabled: true,
    // });
      } catch (e) {
    // If already initialized or any other error, just log it
    console.error("AppCheck init error:", e);
  }
}